// extracted by mini-css-extract-plugin
export default {"root":"PageAllEvents_root__kPPIQ","top":"PageAllEvents_top__MXFOz"};